import { useMatches } from "@tanstack/react-router";

export function useActiveFileName(): string | undefined {
  return useMatches({
    select: (matches) => {
      const attachmentsMatch = matches.find(
        (match) =>
          match.routeId ===
          "/(codegen)/codegen/$chatId/attachments/$versionNumber",
      );

      if (!attachmentsMatch) {
        return undefined;
      }

      const search = attachmentsMatch.search as { file?: string };
      return search.file;
    },
  });
}
